var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardTransactionsStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.999 1.31392C16.2347 1.42692 17.3749 2.02612 18.1688 2.97972C18.9627 3.93332 19.3453 5.16323 19.2325 6.39892C18.9975 8.97242 16.805 10.4609 14.1475 10.6324C14.1475 10.6324 12.6575 10.8459 9.8135 9.89442C8.02725 9.33185 6.11956 9.27817 4.3045 9.73942C4.3045 9.73942 6.5765 0.392419 15 1.31392M5.001 20.6859C3.76533 20.5729 2.62514 19.9737 1.83122 19.0201C1.03731 18.0665 0.654679 16.8366 0.767503 15.6009C1.0025 13.0274 3.195 11.5389 5.8525 11.3674C5.8525 11.3674 7.3425 11.1539 10.1865 12.1054C11.9728 12.668 13.8804 12.7217 15.6955 12.2604C15.6955 12.2604 13.424 21.6074 5.001 20.6859Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTransactionsStatus);
export default __webpack_public_path__ + "static/media/dashboard_transactions_status.11f79e4064f713b0629cd931d59e459d.svg";
export { ForwardRef as ReactComponent };